<template>
  <section class="done" v-if="tasks">
    <div class="d-flex flex-column container" ref="actionsDone">
      <template v-for="(task, index) in tasks">
        <div
          class="card task"
          v-if="
            (index < max * page && $mq !== 'sm' && $mq !== 'md') ||
              ($mq === 'sm' || $mq === 'md')
          "
          :key="index"
          :class="[task.type.replace('.', '-')]"
        >
          <div
            class="card-body p-0 m-0 d-flex flex-column flex-md-row align-items-center"
          >
            <div class="row align-items-center w-100">
              <div class="col-7 col-md-9 description">
                <div class="row p-0">
                  <div
                    class="col-12 col-md-2 text-left text-md-center text-primary points p-0"
                  >
                    <strong
                      v-if="task.coins !== 0 || task.type === 'answer.instawin'"
                      >{{ task.coins > 0 ? "+" : null }}{{ task.coins }}
                      {{ $t("Coins") }}</strong
                    >
                  </div>
                  <div class="col-12 col-md-10 p-0">
                    <strong
                      v-if="
                        task.event_title !== undefined &&
                          task.event_title !== ''
                      "
                      >{{ task.event_title }}</strong
                    >
                    <strong v-else id="typeDone">{{
                      getTasksTranslation(task.type)
                    }}</strong>
                  </div>
                </div>
              </div>
              <div class="col-5 col-md-3 text-center">
                {{ task.createdAt | moment("DD/M/YYYY HH:mm") }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <div
        class="moreActions text-center"
        v-if="
          tasks && ($mq !== 'sm' && $mq !== 'md') && tasks.length > max * page
        "
      >
        <a
          :href="moreactions"
          v-if="!paginated"
          class="a-more btn-not-spinner"
          >{{ $t("Scopri di più") }}</a
        >
        <a href="#" @click="addPage" v-else class="a-more btn-not-spinner">{{
          $t("Scopri di più")
        }}</a>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  components: {},
  props: {
    tasks: { default: null },
    moreactions: { default: "#" },
    max: { default: 3 },
    paginated: { default: false }
  },
  computed: {},
  data() {
    return {
      pointer: 0,
      page: 1
    };
  },
  methods: {
    addPage(e) {
      if (e) e.preventDefault();
      if (this.tasks && this.tasks.length > this.max * this.page) this.page++;
    },
    getTasksTranslation(type) {
      switch (type) {
        case "twitter.connect":
          return this.$i18n.t("Connesso account Twitter");
        case "facebook.connect":
          return this.$i18n.t("Connesso account Facebook");
        case "google.connect":
          return this.$i18n.t("Connesso account Google");
        case "linkedin.connect":
          return this.$i18n.t("Connesso account Linkedin");
        case "instagram.connect":
          return this.$i18n.t("Connesso account Instagram");
        case "email.verified":
          return this.$i18n.t("Email verificata");
        case "mobile.verified":
          return this.$i18n.t("Numero di telefono verificato");
        case "reward.redeem":
          return this.$i18n.t("Riscattato un premio");
        case "refer":
          return this.$i18n.t("Invitato un amico");
        case "answer.question":
          return this.$i18n.t("Risposto ad una domanda");
        case "answer.instantwin.question":
          return this.$i18n.t("Risposto ad una domanda del quiz");
        case "answer.survey":
          return this.$i18n.t("Partecipato a un sondaggio");
        case "insert.code.simple":
          return this.$i18n.t("Riscattato un codice");
        case "answer.survey":
          return this.$i18n.t("Partecipato a un sondaggio");
        case "instantwin.alldone":
          return this.$i18n.t("Risposto a tutte le domande del Quiz");
        case "instantwin.alldonecorrect":
          return this.$i18n.t(
            "Risposto correttamente a tutte le domande del Quiz"
          );
        case "instantwin.random.play":
          return this.$i18n.t("Giocato all’Instant Win");
        case "external.download.store":
          return this.$i18n.t("Scaricato un file");
        case "information.read":
          return this.$i18n.t("Preso visione di un’informazione");
        case "prediction":
          return this.$i18n.t("Risposto ad una previsione");
        case "inserted.code.simple":
          return this.$i18n.t("Riscattato un codice");
        default:
          return type;
      }
    }
  }
};
</script>
<style scoped>
.card.task .description {
}
strong {
  font-weight: bold;
}
</style>
